import React from 'react';
import { shape, bool } from 'prop-types';
import usePreviewFile from 'Hooks/files/usePreviewFile';
import useAuth from 'Hooks/useAuth';

import FileIcon from './FileIcon';
import styles from './MessageFile.less';

const MessageFile = ({ message, disableClick = false }) => {
  const { handlePreview } = usePreviewFile();
  const { token } = useAuth();
  const file = message.message?.file?.[0];

  const handleOnClick = () => {
    if (disableClick) return;
    handlePreview(file, token);
  };

  if (!file) return;

  return (
    <div className={styles.fileWrapper} id={`message_${message.id}`} onClick={handleOnClick}>
      <div className={styles.fileIcon}>
        <FileIcon file={file} />
      </div>
      <div className={styles.fileName}>{file.name}</div>
    </div>
  );
};

MessageFile.propTypes = {
  message: shape({}).isRequired,
  disableClick: bool,
};

export default MessageFile;
